import { deepArticles } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function DeepDiveSection() {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          id="deep"
          eyebrow="深度解析"
          title="深度解析 · 拆开看事件的传播逻辑"
          desc="不止复述发生了什么，更关注它是怎么被传播、被误读，以及在哪些节点发生了转向。"
          action="全部解析"
        />

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <div className="overflow-hidden rounded-lg border border-background-300 bg-background-50">
              {deepArticles.map((article) => (
                <article
                  key={article.title}
                  className="group flex cursor-pointer gap-4 border-b border-background-200 p-4 transition-colors last:border-b-0 hover:bg-background-100 md:gap-5 md:p-5"
                >
                  <div className="h-24 w-28 shrink-0 overflow-hidden rounded-md md:h-28 md:w-40">
                    <img
                      src={article.thumb}
                      alt={article.title}
                      title={`${article.chapter} ${article.title} 深度解析`}
                      className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex min-w-0 flex-1 flex-col">
                    <span className="text-[11px] font-bold tracking-wider text-secondary-700">{article.chapter}</span>
                    <h3 className="mt-1.5 font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-lg">
                      {article.title}
                    </h3>
                    <p className="mt-1.5 line-clamp-2 hidden text-sm leading-relaxed text-foreground-600 sm:block">
                      {article.excerpt}
                    </p>
                    <div className="mt-auto flex items-center gap-3 pt-2 text-xs text-foreground-500">
                      <span className="flex items-center gap-1">
                        <i className="ri-file-text-line text-sm" />
                        {article.words}
                      </span>
                      <span className="flex items-center gap-1 text-primary-600">
                        阅读全文
                        <i className="ri-arrow-right-line text-sm" />
                      </span>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <aside className="lg:col-span-4">
            <div className="sticky top-24 rounded-lg border border-accent-300 bg-accent-50 p-5">
              <div className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                  <i className="ri-shield-check-line text-lg" />
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-950">核实清单</h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                看任何爆料前，先过一遍这四步，能过滤掉大部分误读。
              </p>
              <ul className="mt-4 space-y-3">
                {[
                  '找到最早出现的原始出处',
                  '核对每条内容的时间戳',
                  '区分事实描述与主观解读',
                  '至少对照两方公开表述',
                ].map((item, index) => (
                  <li key={item} className="flex items-start gap-3 text-sm text-foreground-800">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-foreground-950 text-[11px] font-bold text-background-50">
                      {index + 1}
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
              <a
                href="#top"
                className="mt-5 flex cursor-pointer items-center justify-center gap-1 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-800"
              >
                查看方法详解
                <i className="ri-arrow-right-line text-base" />
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}